export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.93604 2.78516H19.7873C20.5562 2.78516 21.1795 3.40846 21.1795 4.17734C21.1795 4.30893 21.1608 4.43986 21.1241 4.56621L18.8966 12.2232C18.7236 12.8177 18.1789 13.2265 17.5598 13.2265H9.01841C8.39931 13.2265 7.85458 12.8177 7.68165 12.2232L4.93604 2.78516Z"
                fill="#FDF6E8"
                stroke="url(#paint0_linear_567_1042)"
                strokeLinecap="round"
            />
            <path d="M5.35623 4.17674L4.57548 1.67389C4.39408 1.09235 3.85565 0.696289 3.24647 0.696289H1.17969" stroke="#DAAB69" strokeLinecap="round" />
            <path
                d="M8.9573 17.3628C9.57095 17.3628 10.0684 16.8654 10.0684 16.2517C10.0684 15.6381 9.57095 15.1406 8.9573 15.1406C8.34365 15.1406 7.84619 15.6381 7.84619 16.2517C7.84619 16.8654 8.34365 17.3628 8.9573 17.3628Z"
                fill="#CE9A58"
            />
            <path
                d="M17.8465 17.3628C18.4601 17.3628 18.9576 16.8654 18.9576 16.2517C18.9576 15.6381 18.4601 15.1406 17.8465 15.1406C17.2328 15.1406 16.7354 15.6381 16.7354 16.2517C16.7354 16.8654 17.2328 17.3628 17.8465 17.3628Z"
                fill="#CE9A58"
            />
            <path d="M10.5049 6.27832V9.76143" stroke="#E6BC7A" strokeLinecap="round" />
            <path d="M13.2896 6.27832V9.76143" stroke="#E6BC7A" strokeLinecap="round" />
            <path d="M16.0737 6.27832V9.76143" stroke="#E6BC7A" strokeLinecap="round" />
            <defs>
                <linearGradient id="paint0_linear_567_1042" x1="21.735" y1="2.36306" x2="13.0578" y2="13.2265" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FAD895" />
                    <stop offset="1" stopColor="#CD9957" />
                </linearGradient>
            </defs>
        </svg>
    );
}
